import { Plugin } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";
import type { Node as PmNode } from "prosemirror-model";
import { titleBlockIndex } from "../card-title";
import { serialize } from "./serialization";

// This plugin gives the class `title-line` to the block that gives the title of
// the card. A collapsed section shows only that block, so the first line is the
// same as in the open section. The rule is the one of `cardTitle`. The plugin
// computes the decoration again only when the document changes.
export const titleLinePlugin: Plugin<DecorationSet> = new Plugin({
  state: {
    init: (_, state) => titleDecoration(state.doc),
    apply: (tr, set) => (tr.docChanged ? titleDecoration(tr.doc) : set),
  },
  props: {
    decorations(state) {
      return titleLinePlugin.getState(state);
    },
  },
});

function titleDecoration(doc: PmNode): DecorationSet {
  const index = titleBlockIndex(serialize(doc));
  if (index < 0) return DecorationSet.empty;
  let pos = 0;
  for (let i = 0; i < index; i++) pos += doc.child(i).nodeSize;
  const end = pos + doc.child(index).nodeSize;
  return DecorationSet.create(doc, [Decoration.node(pos, end, { class: "title-line" })]);
}
